module.exports = __webpack_public_path__ + "img/firebase.396aff4b.png";